import { render, staticRenderFns } from "./exchange-invite-code.vue?vue&type=template&id=6744e4e6&scoped=true"
import script from "./exchange-invite-code.vue?vue&type=script&lang=js"
export * from "./exchange-invite-code.vue?vue&type=script&lang=js"
import style0 from "./exchange-invite-code.vue?vue&type=style&index=0&id=6744e4e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744e4e6",
  null
  
)

export default component.exports